import React, { useContext, useEffect, useState } from "react";
import ApplicationContext from "../../../context/index";
import CircularProgress from "@mui/material/CircularProgress";
import BuyflowOverviewForm from "./indexForm";
import useApi from "../../../hooks/useApi";
import { useParams } from "react-router-dom";
import { withStyles } from "@mui/styles";
import { Box } from "@mui/material";
import { ReducerUtils } from "../../../constants/reducers";
import { useHistory } from "react-router";
import { useStyles } from "../indexFormStyles";
import { getRoute, getStorageItem } from "../../../helpers/utils";

function BuyflowOverview({ classes: { loaderBox } }) {
  const { id } = useParams();
  const overviewDetails = useApi(
    `/data/overview.json?partnerId=${getStorageItem("partnerId")}`
  );
  const { state, dispatch } = useContext(ApplicationContext);
  const history = useHistory();
  const [modal, setModal] = useState({
    open: false,
    snackbar: false,
  });
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    dispatchEvent(ReducerUtils.overview.details, overviewDetails);
    setTimeout(() => {
      setIsLoaded(true);
    }, 100);
  }, [overviewDetails]);

  const dispatchEvent = (type, payload) => dispatch({ type, payload });

  const handleProceed = () => {
    if (id == 1) {
      navigateTo(getRoute("healthDeclaration"));
    } else if (id == 2) {
      navigateTo(getRoute("ekycGuideline"));
    } else if (id == 3) {
      navigateTo(getRoute("proposalDetails"));
    } else if (id == 4) {
      navigateTo(getRoute("reviewDetails"));
    } else if (id == 5) {
      navigateTo(getRoute("payment"));
    }
  };

  const handleBack = () => {
    if (id == 1) {
      navigateTo(getRoute("product"));
    } else if (id == 2) {
      navigateTo(getRoute("declaration"));
    } else if (id == 3) {
      navigateTo(getRoute("customer"));
    } else if (id == 4) {
      navigateTo(getRoute("nominee"));
    } else if (id == 5) {
      navigateTo(getRoute("reviewDetails"));
    }
  };

  const navigateTo = (pathname) => history.push({ pathname });

  const onSubmit = (event) => {
    event.preventDefault();

    handleProceed();
  };

  return isLoaded && state.overviewDetails ? (
    <BuyflowOverviewForm
      activeStep={id}
      handleBack={handleBack}
      handleProceed={handleProceed}
      modal={modal}
      onSubmit={onSubmit}
    />
  ) : (
    <Box className={loaderBox}>
      <CircularProgress color={"secondary"} />
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(BuyflowOverview);
